import angular from 'angular';
import { MeurhAdmissoesObservacoesFormController } from './observacoes.form.controller';

export class MeurhAdmissoesObservacoesFormComponent implements angular.IComponentOptions {
	static selector = 'meurhAdmissoesObservacoesFormComponent';
	static controller = MeurhAdmissoesObservacoesFormController;
	static template = require('!!html-loader!./observacoes.form.html');
	static transclude = true;
	static bindings = {
		entity: '=',
		form: '<',
		busy: '=',
		action: '<',
	};
}
